export default __webpack_public_path__ + "4dde9a7f8edce1232f874c9d088f85d1.woff2";